import { useState, useEffect, useCallback, useMemo } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { Modal, Select } from 'antd';
import { useLocation } from 'react-router-dom';
import { AiOutlineClose, AiOutlineDelete } from 'react-icons/ai';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { DeletePersonalTrainingSubscriptionStudentSummaryService, GenerateStudentWeeklyReportService, GetPersonalTrainingSubscriptionStudentSummaryService, UpdatePersonalTrainingSubscriptionStudentSummaryService, GenerateCustomReportMissingService } from '../../services/class_booking/classBookingServices';
import { GetChapterService } from '../../services/admin/ChapterServices';
import { GetSubjectService } from '../../services/admin/SubjectServices';
import SettingsMenu from '../staticscreens/SettingsMenu';
import BatchBookingMenu from '../batch_booking/BatchBookingMenu';
import { GetTeacherSearchService } from '../../services/class_booking/TeacherServices';

function BatchSubscriptionTimeTableStudentSummary() {

  const { state } = useLocation()
  const { pathname }  = useLocation()
  const roles = useSelector(state => state.Auth.roles)
  const user = useSelector(state => state.Auth)
  const isTeacherUser = user?.logged_user_type === 'Teacher'
  const currentTeacherId = user?.id || user?._id


  const [modal, setmodal] = useState(false)
  const [downloadmodal, setdownloadmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})
  const [updating, setupdating] = useState(false)
  const [loading, setloading] = useState(false)
  const [updatedData, setupdatedData] = useState({})
  const [showTestEditor, setshowTestEditor] = useState({})
  const [showFeedbackEditor, setshowFeedbackEditor] = useState({})
  const [subjectOptions, setsubjectOptions] = useState([])
  const [teacherOptions, setteacherOptions] = useState([])
  const [chapterOptionsBySubject, setchapterOptionsBySubject] = useState({})
  const teacherMode = state?.personal_training_subscription_teacher_batch?.mode || 'online'
  const [downLoadData,setDownLoadData] = useState({})
  const [downloading,setDownloading] = useState(false)
  

  const quickRemarkTemplates = [
    'Good focus in class',
    'Needs more practice',
    'Homework not completed',
    'Excellent participation',
    'Improve revision consistency'
  ]

  const attendanceOptions = [
    { value: 'present', label: 'Present', activeClass: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
    { value: 'absent', label: 'Absent', activeClass: 'bg-red-100 text-red-700 border-red-300' },
    { value: 'leave', label: 'Leave', activeClass: 'bg-amber-100 text-amber-700 border-amber-300' }
  ]

  const getdata = useCallback(async () => {
    if (!state?._id || !state?.date) return;
    
    setloading(true)
    try {
      const response = await GetPersonalTrainingSubscriptionStudentSummaryService(state?._id, moment(state?.date).format('YYYY-MM-DD'));
      if (response?.status === 200) {
        setdata(response?.data)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
      toast.error("Failed to fetch data")
    } finally {
      setloading(false)
    }
  }, [state?._id, state?.date])

  useEffect(() => {
    getdata()
  }, [page, getdata])

  // useEffect(() => {
  //   getSubjectOptions()
  // }, [])

  useEffect(() => {
    getTeacherOptions('', teacherMode)
  }, [teacherMode])

  const reports = data?.data || []

  // useEffect(() => {
  //   const reportSubjectIds = Array.from(new Set((reports || []).map((item) => getObjectId(item?.subject) || getObjectId(item?.test_info?.subject)).filter(Boolean)))
  //   reportSubjectIds.forEach((subjectId) => {
  //     getChapterOptionsBySubject(subjectId)
  //   })
  // }, [reports])

  const summary = useMemo(() => {
    const present = reports.filter((item) => item?.attendance_status === 'present').length
    const absent = reports.filter((item) => item?.attendance_status === 'absent').length
    const leave = reports.filter((item) => item?.attendance_status === 'leave').length

    return {
      total: reports.length,
      present,
      absent,
      leave,
      pendingChanges: Object.keys(updatedData).length
    }
  }, [reports, updatedData])

  function getDraftValue(row, field) {
    const draft = updatedData[row?._id]
    if (draft && draft[field] !== undefined) {
      return draft[field]
    }
    return row?.[field]
  }

  function getTestDraftValue(row, field) {
    const draft = updatedData[row?._id]
    if (draft?.test_info && draft?.test_info[field] !== undefined) {
      return draft?.test_info[field]
    }
    return row?.test_info?.[field]
  }

  function normalizePayload(updateFields = {}) {
    const payload = { ...updateFields }

    if (payload.performance_rating !== undefined) {
      payload.performance_rating = Number(payload.performance_rating || 0)
    }

    if (payload.test_info) {
      payload.test_info = {
        ...payload.test_info,
        marks: payload?.test_info?.marks || ''
      }
    }

    return payload
  }

  // async function getSubjectOptions() {
  //   try {
  //     const response = await GetSubjectService({})
  //     const options = (response?.data?.datas || []).map((item) => ({
  //       value: item?._id,
  //       label: item?.name
  //     }))
  //     setsubjectOptions(options)
  //   } catch (error) {
  //     console.error('Error fetching subjects:', error)
  //   }
  // }

  // async function getChapterOptionsBySubject(subjectId = '') {
  //   if (!subjectId || chapterOptionsBySubject?.[subjectId]) {
  //     return
  //   }

  //   try {
  //     const response = await GetChapterService({ subject: subjectId })
  //     const options = (response?.data?.datas || []).map((item) => ({
  //       value: item?._id,
  //       label: item?.title || `Chapter ${item?.chapter_number || ''}`.trim()
  //     }))

  //     setchapterOptionsBySubject((prev) => ({
  //       ...prev,
  //       [subjectId]: options
  //     }))
  //   } catch (error) {
  //     console.error('Error fetching chapters:', error)
  //   }
  // }

  async function updateStudentSummary(id, updateFields, showToast = true) {
    setupdating(true)
    try {
      const response = await UpdatePersonalTrainingSubscriptionStudentSummaryService(id, normalizePayload(updateFields))
      if (response?.status === 200) {
        if (showToast) {
          toast.success("Updated Successfully")
        }
        return true
      } else {
        if (showToast) {
          toast.error("Update failed")
        }
        return false
      }
    } catch (error) {
      console.error("Error updating:", error)
      toast.error("Error updating data")
      return false
    } finally {
      setupdating(false)
    }
  }

  async function handleUpdateAll() {
    const entries = Object.entries(updatedData)
    if (entries.length === 0) {
      toast.error('No pending changes to update')
      return
    }

    setupdating(true)
    try {
      const results = await Promise.all(entries.map(([id, payload]) =>
        UpdatePersonalTrainingSubscriptionStudentSummaryService(id, normalizePayload(isTeacherUser && currentTeacherId ? { ...payload, teacher: currentTeacherId } : payload))
      ))

      const successCount = results.filter((item) => item?.status === 200).length
      const failedCount = entries.length - successCount

      if (successCount > 0) {
        toast.success(`${successCount} report${successCount > 1 ? 's' : ''} updated`)
      }
      if (failedCount > 0) {
        toast.error(`${failedCount} update${failedCount > 1 ? 's' : ''} failed`)
      }

      if (successCount > 0) {
        setupdatedData({})
        getdata()
      }
    } catch (error) {
      console.error('Error updating all:', error)
      toast.error('Failed to update reports')
    } finally {
      setupdating(false)
    }
  }

  async function deleteData() {
    if (!selecteddata?._id) return;
    
    setloading(true)
    try {
      const response = await DeletePersonalTrainingSubscriptionStudentSummaryService(selecteddata?._id)
      if (response?.status === 200) {
        toast.success("Deleted Successfully")
        setmodal(false)
        setselecteddata({})
        getdata()
      } else {
        toast.error("Delete failed")
      }
    } catch (error) {
      console.error("Error deleting:", error)
      toast.error("Error deleting data")
    } finally {
      setloading(false)
    }
  }

  const handleAttendanceChange = (studentSummaryId, value) => {
    setupdatedData(prev => ({
      ...prev,
      [studentSummaryId]: {
        ...prev[studentSummaryId],
        attendance_status: value
      }
    }))
  }

  const handlePerformanceRatingChange = (studentSummaryId, value) => {
    setupdatedData(prev => ({
      ...prev,
      [studentSummaryId]: {
        ...prev[studentSummaryId],
        performance_rating: value
      }
    }))
  }

  const handleFeedbackChange = (studentSummaryId, value) => {
    setupdatedData(prev => ({
      ...prev,
      [studentSummaryId]: {
        ...prev[studentSummaryId],
        feedback: value
      }
    }))
  }

  const handleRemarksChange = (studentSummaryId, value) => {
    setupdatedData(prev => ({
      ...prev,
      [studentSummaryId]: {
        ...prev[studentSummaryId],
        remarks: value
      }
    }))
  }

  const handleTopicsCoveredChange = (studentSummaryId, value) => {
    setupdatedData(prev => ({
      ...prev,
      [studentSummaryId]: {
        ...prev[studentSummaryId],
        topics_covered: value
      }
    }))
  }


  const handleTestInfoChange = (studentSummaryId, key, value) => {
    const existStudentSummary = data?.data?.find(
      (item) => item?._id === studentSummaryId
    );

    setupdatedData((prev) => {
      return {
        ...prev,
        [studentSummaryId]: {
          ...(prev[studentSummaryId] || {}),
          test_info: {
            ...(existStudentSummary?.test_info || {}),
            ...(prev[studentSummaryId]?.test_info || {}),
            [key]: value,
          },
        },
      };
    });
  };

  function handleTeacherChange(studentSummaryId, value) {
    setupdatedData((prev) => ({
      ...prev,
      [studentSummaryId]: {
        ...prev[studentSummaryId],
        teacher: value || null,
        chapter: null,
        test_info: {
          ...(prev[studentSummaryId]?.test_info || {}),
          teacher: value || null
        }
      }
    }))
  }

  function handleSubjectChange(studentSummaryId, value) {
    setupdatedData((prev) => ({
      ...prev,
      [studentSummaryId]: {
        ...prev[studentSummaryId],
        subject: value || null,
        chapter: null,
        test_info: {
          ...(prev[studentSummaryId]?.test_info || {}),
          subject: value || null
        }
      }
    }))

    // if (value) {
    //   getChapterOptionsBySubject(value)
    // }
  }

  function handleChapterChange(studentSummaryId, value) {
    setupdatedData((prev) => ({
      ...prev,
      [studentSummaryId]: {
        ...prev[studentSummaryId],
        chapter: value || null
      }
    }))
  }

  function getObjectId(value) {
    if (!value) {
      return ''
    }
    if (typeof value === 'object') {
      return value?._id || ''
    }
    return value
  }

  function hasExistingTestData(row) {
    const hasMarks = row?.test_info?.marks !== undefined && row?.test_info?.marks !== null && row?.test_info?.marks !== ''
    const hasRemarks = Boolean((row?.test_info?.remarks || '').trim())

    return hasMarks || hasRemarks
  }

  function toggleTestEditor(row) {
    const rowId = row?._id
    const subjectId = getObjectId(getDraftValue(row, 'subject') || getTestDraftValue(row, 'subject'))

    setshowTestEditor((prev) => ({
      ...prev,
      [rowId]: !prev?.[rowId]
    }))

    // if (subjectId) {
    //   getChapterOptionsBySubject(subjectId)
    // }
  }

  function resolveSubjectLabel(row) {
    const subjectId = getObjectId(getDraftValue(row, 'subject') || getTestDraftValue(row, 'subject'))
    if (subjectId) {
      return subjectOptions.find((item) => item.value === subjectId)?.label || row?.subject?.name || 'N/A'
    }
    return row?.subject?.name || 'N/A'
  }

  function resolveChapterLabel(row) {
    const subjectId = getObjectId(getDraftValue(row, 'subject') || getTestDraftValue(row, 'subject'))
    const chapterId = getObjectId(getDraftValue(row, 'chapter'))
    if (chapterId) {
      const chapterOptions = chapterOptionsBySubject?.[subjectId] || []
      return chapterOptions.find((item) => item.value === chapterId)?.label || row?.chapter?.title || row?.chapter?.name || 'N/A'
    }
    return row?.chapter?.title || row?.chapter?.name || 'N/A'
  }

  function clearDraftForRow(id) {
    setupdatedData((prev) => {
      const nextData = { ...prev }
      delete nextData[id]
      return nextData
    })
  }

  function toggleFeedbackEditor(id) {
    setshowFeedbackEditor((prev) => ({
      ...prev,
      [id]: !prev?.[id]
    }))
  }

  function addQuickRemark(row, remarkTemplate) {
    const currentRemark = (getDraftValue(row, 'remarks') || '').trim()
    const nextRemark = currentRemark ? `${currentRemark}${currentRemark.endsWith('.') ? ' ' : '. '}${remarkTemplate}` : remarkTemplate
    handleRemarksChange(row?._id, nextRemark)
  }

  const handleUpdate = async (d) => {
    let updates = updatedData[d?._id]

    if (isTeacherUser && currentTeacherId) {
      updates = { ...(updates || {}), teacher: currentTeacherId }
    }

    if (updates && Object.keys(updates).length > 0) {
      const success = await updateStudentSummary(d?._id, updates)
      if (success) {
        clearDraftForRow(d?._id)
        getdata()
      }
    } else {
      toast.error("No changes to update")
    }
  }

  if (loading && !data?.data?.length) {
    return (
      <div className='w-[98%] md:h-screen md:overflow-hidden'>
        <div className='md:flex'>
          <div><SettingsMenu /></div>
          <div className='md:w-[90%] pl-5 mt-4'>
            <div className='flex justify-center items-center h-64'>
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
                <p className="mt-4 text-gray-600">Loading...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // state?.personal_training_subscription_teacher_batch?.mode

  async function getTeacherOptions(search = '', mode = teacherMode) {
    try {
      const response = await GetTeacherSearchService(search, 1, 'Batch', mode)
      if (response?.status === 200) {
        const options = (response?.data?.datas || []).map((item) => ({
          label: item?.name,
          value: item?._id
        }))
        setteacherOptions(options)
      }
    } catch (error) {
      console.error('Error fetching teachers:', error)
    }
  }

  async function generatePDF() {
    setDownloading(true)
    const response = await GenerateStudentWeeklyReportService()
    if (response?.status === 200) {
      setDownloading(false)
      setDownLoadData(response?.data)
      setdownloadmodal(true)
      toast.success('Weekly report generated')
      return
    }
    setDownloading(false)
    toast.error('Unable to generate weekly report')
  }

  async function regenerateMissingDocs() {
    const response = await GenerateCustomReportMissingService(state?._id)
    if(response?.status === 200) {
      toast.success(response?.data?.message)
    }else{
      toast.error(JSON.stringify(response?.data?.message || 'Unable to recover Missing Report'))
    }
  }

  const docsLength = data?.data?.length ?? 0;
  const studentsLength = state?.students?.length ?? 0;
  const batchStudentsLength = state?.personal_training_subscription_teacher_batch?.students?.length ?? 0;

  const showRegenerate = roles?.includes('admin') && (docsLength !== studentsLength || docsLength !== batchStudentsLength);

  
  return (
    <div className='w-full md:h-screen md:overflow-hidden'>
      <Modal
        open={modal}
        onCancel={() => setmodal(false)}
        width={300}
        footer={null}
        closable={true}
      >
        <div>
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3'>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={loading ? 'Deleting...' : 'Confirm'} onClick={() => deleteData()} disabled={loading} />
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        open={downloadmodal}
        onCancel={() => setdownloadmodal(false)}
        footer={null} closable={true} 
        >
        <div className='p-2 relative'>
          <h6 className='font-bold text-[15px] mb-3'>Overall Report Generated</h6>
          {downLoadData?.reports?.map((d)=>(
            <div className='border rounded-md p-3 mb-2 flex flex-col gap-1' key={d?.batchId}>
               <h6 className='font-[600] text-[14px]'>{d?.batchName} <span className='text-[12px] text-slate-500'>Slot : {d?.slot}</span></h6>
               <div>
               <ButtonFilledAutoWidth btnName={'Download Report'} onClick={() => window.open(d?.url, '_blank')} />
               </div>
            </div>  
          ))}
        </div>  
      </Modal>

      <div className='md:flex'>
        <div>
          {pathname === '/batches_booking/list/time_table/student_summary' ? <BatchBookingMenu state={state} /> : <SettingsMenu />}
        </div>
        <div className='md:w-[90%] pl-5 pr-2 mt-4'>
          <div className='md:flex mr-2 items-center -mt-1 border-b justify-between pb-2'>
            <div className='flex flex-col py-3'>
              <h6 className='font-[800] text-[14px]'>Student Day-Wise Report ({summary.total})</h6>
              <h6 className='text-[11px] text-slate-500 mt-1'>Update attendance status, rating, feedback, remarks and test details in one place.</h6>
            </div>

            <div className='flex flex-wrap gap-2 items-center'>
              {showRegenerate &&
              <ButtonFilledAutoWidth onClick={regenerateMissingDocs} btnName={'Regenerate Missing Docs'} />
              }
              <ButtonOutlinedAutoWidth onClick={handleUpdateAll} btnName={updating ? 'Saving...' : `Save All (${summary.pendingChanges})`} />
              {roles?.includes('admin') && <ButtonFilledAutoWidth onClick={!downloading ? generatePDF : null} btnName={downloading ? 'Generating...' : 'Generate Weekly PDF'} />}
            </div>
          </div>

          <div className='grid grid-cols-2 md:grid-cols-5 gap-2 my-3 mr-2'>
            <div className='border rounded-md p-2 bg-white'>
              <h6 className='text-[10px] text-slate-500'>Total</h6>
              <h6 className='text-[16px] font-[700]'>{summary.total}</h6>
            </div>
            <div className='border rounded-md p-2 bg-emerald-50 border-emerald-200'>
              <h6 className='text-[10px] text-emerald-700'>Present</h6>
              <h6 className='text-[16px] font-[700] text-emerald-700'>{summary.present}</h6>
            </div>
            <div className='border rounded-md p-2 bg-red-50 border-red-200'>
              <h6 className='text-[10px] text-red-700'>Absent</h6>
              <h6 className='text-[16px] font-[700] text-red-700'>{summary.absent}</h6>
            </div>
            <div className='border rounded-md p-2 bg-amber-50 border-amber-200'>
              <h6 className='text-[10px] text-amber-700'>Leave</h6>
              <h6 className='text-[16px] font-[700] text-amber-700'>{summary.leave}</h6>
            </div>
            <div className='border rounded-md p-2 bg-blue-50 border-blue-200'>
              <h6 className='text-[10px] text-blue-700'>Unsaved</h6>
              <h6 className='text-[16px] font-[700] text-blue-700'>{summary.pendingChanges}</h6>
            </div>
          </div>

          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>
            {data?.data?.length === 0 && !loading &&
              <div className='grid place-items-center mt-20 items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' alt="No data" />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-full h-max'>
              {data?.data?.length > 0 &&
                <div className='h-full md:max-h-[75vh] mt-3 md:overflow-y-auto pr-2'>
                  {data?.data?.map((d, i) => {
                    const subjectId = getObjectId(getDraftValue(d, 'subject') || getTestDraftValue(d, 'subject'))
                    const teacherId = isTeacherUser ? currentTeacherId : getObjectId(getDraftValue(d, 'teacher') || getTestDraftValue(d, 'teacher'))
                    const chapterId = getObjectId(getDraftValue(d, 'chapter'))
                    const chapterOptions = subjectId ? (chapterOptionsBySubject?.[subjectId] || []) : []
                    const testEditorVisible = Boolean(showTestEditor?.[d?._id])

                    return (
                    <div key={d?._id || i} className='bg-white border rounded-md mb-3 overflow-hidden'>
                      <div className='px-3 py-2 border-b bg-slate-50 flex flex-wrap justify-between items-center gap-2'>
                        <div>
                          <h6 className='font-[700] text-[12px]'>
                            #{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)} - {d?.student?.name || 'N/A'}
                          </h6>
                          <h6 className='text-[11px] text-slate-600'>
                            {!isTeacherUser && `${d?.student?.mobile || 'N/A'} | `}{moment(d?.date)?.format('LL') || 'N/A'}
                          </h6>
                        </div>

                        <div className='flex items-center gap-2'>
                          <span className='text-[10px] px-2 py-[2px] rounded-full border bg-white text-slate-600'>
                            Created: {moment(d?.createdAt)?.format('ll') || 'N/A'}
                          </span>
                          {updatedData[d?._id] && <span className='text-[10px] px-2 py-[2px] rounded-full border bg-blue-50 border-blue-200 text-blue-700'>Unsaved</span>}
                        </div>
                      </div>

                      <div className='p-3 grid grid-cols-1 md:grid-cols-2 gap-3'>
                        <div>
                          <h6 className='text-[11px] mb-1 font-[600]'>Attendance Status</h6>
                          <div className='flex gap-1.5 flex-wrap'>
                            {attendanceOptions.map((statusItem) => {
                              const active = (getDraftValue(d, 'attendance_status') || 'absent') === statusItem.value
                              return (
                                <button
                                  key={statusItem.value}
                                  onClick={() => handleAttendanceChange(d?._id, statusItem.value)}
                                  className={`text-[11px] px-2.5 py-1 rounded-full border transition-colors ${active ? statusItem.activeClass : 'bg-white text-slate-600 border-slate-300 hover:bg-slate-100'}`}
                                >
                                  {statusItem.label}
                                </button>
                              )
                            })}
                          </div>

                          <div className='mt-3'>
                            <h6 className='text-[11px] mb-1 font-[600]'>Teacher Info</h6>
                            {isTeacherUser ? (
                              <div className='w-full border rounded-[6px] h-[28px] border-slate-300 bg-slate-100 text-slate-700 text-[12px] px-2 flex items-center'>
                                {user?.name || user?.email || 'Teacher'}
                              </div>
                            ) : (
                             <Select
                                showSearch
                                value={teacherId || undefined}
                                allowClear
                                filterOption={false}
                                bordered={false}
                                placeholder='Select Teacher'
                                onChange={(value) => handleTeacherChange(d?._id, value)}
                                onSearch={(value) => getTeacherOptions(value, teacherMode)}
                                options={teacherOptions}
                                className='w-full border rounded-[6px] h-[28px] border-slate-300 outline-0 focus:outline-0 focus:ring-0 focus:border-transparent'
                              />
                            )}
                          </div>

                          {/* <div className='mt-3'>
                            <h6 className='text-[11px] mb-1 font-[600]'>Performance Rating (0-5)</h6>
                            <input
                              value={getDraftValue(d, 'performance_rating') ?? 0}
                              onChange={(event) => handlePerformanceRatingChange(d?._id, event.target.value)}
                              type='number'
                              min='0'
                              max='5'
                              className='w-full border border-slate-300 text-[12px] rounded px-2 py-1.5 outline-none focus:ring-0'
                            />
                          </div> */}

                          <div className='grid mt-2 grid-cols-1 md:grid-cols-2 gap-3'>
                            <div>
                              <h6 className='text-[11px] mb-1 font-[600]'>Subject</h6>
                              <input
                                value={getDraftValue(d, 'subject') || ''}
                                onChange={(event) => handleSubjectChange(d?._id, event.target.value)}
                                placeholder='Enter subject'
                                className='w-full border border-slate-300 text-[12px] rounded px-2 py-1.5 outline-none focus:ring-0'
                              />
                              {/* <Select
                                value={subjectId || undefined}
                                allowClear
                                bordered={false}
                                placeholder='Select Subject'
                                onChange={(value) => handleSubjectChange(d?._id, value)}
                                options={subjectOptions}
                                className='w-full border rounded-[6px] h-[28px] border-slate-300 outline-0 focus:outline-0 focus:ring-0 focus:border-transparent'
                              /> */}
                            </div>

                            <div>
                              <h6 className='text-[11px] mb-1 font-[600]'>Chapter</h6>
                              <input
                                value={getDraftValue(d, 'chapter') || ''}
                                onChange={(event) => handleChapterChange(d?._id, event.target.value)}
                                placeholder='Enter chapter'
                                className='w-full border border-slate-300 text-[12px] rounded px-2 py-1.5 outline-none focus:ring-0'
                              />
                              {/* <Select
                                value={chapterId || undefined}
                                allowClear
                                bordered={false}
                                disabled={!subjectId}
                                placeholder={subjectId ? 'Select Chapter' : 'Select Subject First'}
                                onChange={(value) => handleChapterChange(d?._id, value)}
                                options={chapterOptions}
                                className='w-full border rounded-[6px] h-[28px] border-slate-300 outline-0 focus:outline-0 focus:ring-0 focus:border-transparent'
                              /> */}
                            </div>
                          </div>

                          {/* <div className='border border-slate-300 rounded-md mt-2 p-2.5 bg-white mb-4'>
                            <h6 className='text-[11px] mb-1 font-[700]'>Topics Covered</h6>
          
                            <textarea
                              value={getDraftValue(d, 'topics_covered') || ''}
                              onChange={(event) => handleTopicsCoveredChange(d?._id, event.target.value)}
                              rows={3}
                              placeholder='Add topics covered...'
                              className='w-full border border-slate-300 text-[12px] rounded px-2 py-1.5 outline-none focus:ring-0'
                            />
                          </div>   */}

                        </div>

                        <div>
                        
                          <div className='border border-slate-300 md:mt-[70px] rounded-md p-2.5 bg-white'>
                            <h6 className='text-[11px] mb-1 font-[700]'>Student Remarks</h6>
                            {/* <h6 className='text-[10px] text-slate-500 mb-2'>Primary note for this student. Use quick templates for faster entry.</h6>

                            <div className='flex flex-wrap gap-1 mb-2'>
                              {quickRemarkTemplates.map((template) => (
                                <button
                                  key={template}
                                  onClick={() => addQuickRemark(d, template)}
                                  className='text-[10px] px-2 py-0.5 rounded-full border border-slate-300 bg-slate-50 hover:bg-slate-100'
                                >
                                  + {template}
                                </button>
                              ))}
                            </div> */}

                            <textarea
                              value={getDraftValue(d, 'remarks') || ''}
                              onChange={(event) => handleRemarksChange(d?._id, event.target.value)}
                              rows={3}
                              placeholder='Add student remark...'
                              className='w-full border border-slate-300 text-[12px] rounded px-2 py-1.5 outline-none focus:ring-0'
                            />

                            <div className='flex items-center justify-between mt-1.5'>
                              <h6 className='text-[10px] text-slate-500'>
                                {(getDraftValue(d, 'remarks') || '').length} characters
                              </h6>

                              <button
                                onClick={() => toggleFeedbackEditor(d?._id)}
                                className='text-[10px] px-2 py-0.5 rounded border border-slate-300 bg-white hover:bg-slate-100'
                              >
                                {showFeedbackEditor?.[d?._id] ? 'Hide Parent Feedback' : 'Add Parent Feedback'}
                              </button>
                            </div>

                            {showFeedbackEditor?.[d?._id] &&
                              <div className='mt-2'>
                                <h6 className='text-[11px] mb-1 font-[600]'>Parent Feedback (Optional)</h6>
                                <textarea
                                  value={getDraftValue(d, 'feedback') || ''}
                                  onChange={(event) => handleFeedbackChange(d?._id, event.target.value)}
                                  rows={2}
                                  placeholder='Add feedback message for parent communication...'
                                  className='w-full border border-slate-300 text-[12px] rounded px-2 py-1.5 outline-none focus:ring-0'
                                />
                              </div>}
                          </div>
                        </div>

                        {/* <div className='md:col-span-2 border rounded-md p-3 bg-gradient-to-r from-slate-50 to-blue-50'>
                          <h6 className='text-[11px] font-[700] mb-2'>Learning Mapping</h6>
                          
                        </div> */}

                        <div className='md:col-span-2 border rounded-md p-3 bg-slate-50'>
                          <div className='flex items-center justify-between'>
                            <h6 className='text-[11px] font-[700]'>Test Result (Optional)</h6>
                            <button
                              onClick={() => toggleTestEditor(d)}
                              className='text-[11px] px-2.5 py-1 rounded-md border border-slate-300 bg-white hover:bg-slate-100'
                            >
                              {testEditorVisible ? 'Hide Test Result' : (hasExistingTestData(d) ? 'View Test Result' : 'Add Test Result')}
                            </button>
                          </div>

                          {testEditorVisible &&
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-3 mt-2'>
                              <div>
                                <h6 className='text-[11px] mb-1 font-[600]'>Test Marks</h6>
                                <input
                                  value={getTestDraftValue(d, 'marks') ?? ''}
                                  onChange={(event) => handleTestInfoChange(d?._id, 'marks', event.target.value)}
                                  type='text'
                                  className='w-full border border-slate-300 text-[12px] rounded px-2 py-1.5 outline-none focus:ring-0'
                                />
                              </div>

                              <div>
                                <h6 className='text-[11px] mb-1 font-[600]'>Test Remarks</h6>
                                <textarea
                                  value={getTestDraftValue(d, 'remarks') || ''}
                                  onChange={(event) => handleTestInfoChange(d?._id, 'remarks', event.target.value)}
                                  rows={2}
                                  className='w-full border border-slate-300 text-[12px] rounded px-2 py-1.5 outline-none focus:ring-0'
                                />
                              </div>
                            </div>}
                        </div>
                      </div>

                      <div className='px-3 py-2 border-t bg-white flex items-center justify-between'>
                        <h6 className='text-[11px] text-slate-500'>
                          Subject: {resolveSubjectLabel(d)} | Chapter: {resolveChapterLabel(d)}
                        </h6>

                        <div className='flex items-center gap-2'>
                          <ButtonOutlinedAutoWidth btnName='Reset Row' onClick={() => clearDraftForRow(d?._id)} />
                          <ButtonFilledAutoWidth
                            btnName={updating ? 'Updating...' : 'Update'}
                            onClick={() => handleUpdate(d)}
                            disabled={updating}
                          />
                          {roles?.includes('admin') &&
                            <AiOutlineDelete
                              onClick={() => {
                                setselecteddata(d)
                                setmodal(true)
                              }}
                              className='cursor-pointer hover:text-red-600'
                              size={16}
                            />}
                        </div>
                      </div>
                    </div>
                    )})}
                </div>
              }

              <div className='min-h-[100px] h-[100px] max-h-[100px]'>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BatchSubscriptionTimeTableStudentSummary